import ProjectDataSection from './ProjectDataSection';
import ProjectFormationSection from './ProjectFormationSection';
import ProjectLastSectionFirstType from './ProjectLastSectionFirstType';
import ProjectPublicationsSection from './ProjectPublicationsSection';
import ProjectResultsSection from './ProjectResultsSection';
import ProjectFinancialInclusionSection from './ProjectFinancialInclusionSection';
export default class ProjectFirstType {
    constructor(projects) {
        const { id, data_section, formation_section, results_impacts_section, last_section_first_type, publications_section, financial_inclusion_section } = projects;
        this.id = id;
        this.data_section = data_section ? new ProjectDataSection(data_section) : undefined;
        this.formation_section = formation_section
            ? new ProjectFormationSection(formation_section)
            : undefined;
        this.result_section = results_impacts_section
            ? new ProjectResultsSection(results_impacts_section)
            : undefined;
        this.last_section_first_type = last_section_first_type
            ? new ProjectLastSectionFirstType(last_section_first_type)
            : undefined;
        this.publications_section = publications_section
            ? new ProjectPublicationsSection(publications_section)
            : undefined;
        this.financial_inclusion_section = financial_inclusion_section
            ? new ProjectFinancialInclusionSection(financial_inclusion_section)
            : undefined;
    }
}
